import React, { useState } from "react"
import {
  VStack,
  Checkbox,
  Box,
  Button,
  ModalFooter,
  ModalBody,
  ModalHeader,
  ModalCloseButton,
  Text,
  Link
} from "@chakra-ui/react"

interface SelectSegmentsProps {
  companyIds: { id: string | number; countryCode: string; name: string }[]
  onSubmit: (
    selectedIds: { id: string | number; countryCode: string; name: string }[],
    hasInternationalSegment: boolean
  ) => void
  onClose: () => void
}

export default function SelectSegments({ companyIds, onSubmit, onClose }: SelectSegmentsProps) {
  const [selectedIds, setSelectedIds] = useState<{ id: string | number; countryCode: string; name: string }[]>([])

  const handleCheckboxChange = (id: string | number, countryCode: string, name: string) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.some((item) => item.id === id)
        ? prevSelectedIds.filter((item) => item.id !== id)
        : [...prevSelectedIds, { id, countryCode, name }]
    )
  }

  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedIds(companyIds)
    } else {
      setSelectedIds([])
    }
  }

  const handleNext = () => {
    const hasInternationalSegment = selectedIds.some((id) => id.countryCode !== "US")
    onSubmit(selectedIds, hasInternationalSegment)
  }

  return (
    <>
      <ModalHeader>Select the segments for launch</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <VStack spacing={4} align="start" width="100%">
          <Checkbox isChecked={selectedIds.length === companyIds.length} onChange={handleSelectAll}>
            Select All
          </Checkbox>
          <Box maxHeight="300px" overflowY="scroll" width="100%">
            <VStack align="start">
              {companyIds.map(({ id, countryCode, name }) => (
                <Checkbox
                  key={id}
                  isChecked={selectedIds.some((item) => item.id === id)}
                  onChange={() => handleCheckboxChange(id, countryCode, name)}
                >
                  {name} ({id})
                </Checkbox>
              ))}
            </VStack>
          </Box>
          <Text fontSize="small">
            Do not select Cobra segments, segments in{" "}
            <Link
              href="https://airtable.com/appmqAIXpH7HVPAU5/shr3QhLD6oThiHIKU/tblNejGG3A1DSebqG"
              isExternal
              color="blue.500"
            >
              restricted areas
            </Link>
            {""}, or segments with existing Carrot Card configuration.
          </Text>
        </VStack>
      </ModalBody>
      <ModalFooter>
        <Button mr={3} onClick={onClose}>
          Cancel
        </Button>
        <Button colorScheme="carrotOrange" onClick={handleNext} isDisabled={selectedIds.length === 0}>
          Next
        </Button>
      </ModalFooter>
    </>
  )
}
